<template>
<div data-aos="fade-left">
    <nav>
        <router-link to="/" class="nav-logo">
            <img src="../assets/cleandata_logo.svg" />
        </router-link>

        <div class="nav-links" v-if="!mobile">
            <a href="#services">Lösungen</a>
            <a href="#resume">Mein Bereich</a>
            <a href="#pricing">Preise</a>
            <a href="#contact">Kontakt</a>
        </div>

        <div class="nav-btns" v-if="!mobile">
            <router-link v-if="!currentUser" to="/login" class="default-btn default-login-btn">EINLOGGEN</router-link>
            <router-link v-if="!currentUser" to="/register" class="default-btn default-started-btn">JETZT STARTEN</router-link>
            <router-link v-if="currentUser" to="/dashboard" class="default-btn default-started-btn">DASHBOARD</router-link>
        </div>

        <div v-if="mobile" @click="toggleMobileMenu()">
            <div class="menu-btn">
                <img src="../assets/icons/menu_button.svg" />
            </div>
        </div>
    </nav>

    <div v-if="mobile" class="mobile-menu" :class="{ 'mobile-menu-opened': slideMobMenu }">
        <div @click="toggleMobileMenu()" class="menu-btn close-menu-btn">
            <img src="../assets/icons/closemenu_icon.svg" />
        </div>

        <div class="dsb-menu">
            <div @click="toggleMobileMenu()" class="menu-link-wrapper">
                <a href="#services">Lösungen</a>
            </div>

            <div @click="toggleMobileMenu()" class="menu-link-wrapper">
                <a href="#resume">Mein Bereich</a>
            </div>

            <div @click="toggleMobileMenu()" class="menu-link-wrapper">
                <a href="#pricing">Preise</a>
            </div>

            <div @click="toggleMobileMenu()" class="menu-link-wrapper">
                <a href="#contact">Kontakt</a>
            </div>

            <div class="menu-link-wrapper login-menu-link-wrapper">
                <router-link to="/login">EINLOGGEN</router-link>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default { 
    data() {
        return {
            mobile: false,
            slideMobMenu: false,
        }
    },
    methods: {
        checkIfMobile() {
            if (window.innerWidth <= 768) {
                this.mobile = true;
            } else {
                this.mobile = false;
            }
        },

        toggleMobileMenu() {
            this.slideMobMenu = !this.slideMobMenu;
        }

    },
    mounted() {
        this.checkIfMobile();

        window.addEventListener("resize", this.checkIfMobile);
    },
    beforeUnmount() {
        window.removeEventListener("resize", this.checkIfMobile);
    },
}
</script>

<style lang="scss" scoped>   
///
nav { 
    width: 78%;
    margin: 0 auto;
    margin-top: 26px;

    display: flex;
    align-items: center;
    justify-content: space-between;


    .nav-logo {
        display: block; 
        width: 140px;

        img {
            width: 100%;
        }
    }

    .nav-links {
        display: flex;
        align-items: center;
        gap: 42px; 

        a { 
            font-size: 22px;
            color: #3C3C3C;
            cursor: pointer;
        }
    }

    .nav-btns {
        display: flex;
        align-items: center;
        gap: 31px; 
    }
}
 
.default-btn {
    display: block;
    width: 186px;
    cursor: pointer;
    border-radius: 20px;  
    text-align: center;  
    transition: 0.3s ease;
    color: white;
    background-color: #FA3A67;
    border: 1px solid #FA3A67; 
    padding: 12px 0; 
    font-size: 19px;

    &:hover{
        background-color: white;
        color: #FA3A67;
        border: 1px solid #FA3A67;
    }
}

.default-login-btn {
    color: #FA3A67;
    border: 1px solid #FA3A67;
    background-color: white;
    &:hover{
        background-color: #FA3A67;
        color: white; 
    }
}
 
 
/* imac 24" */
/* 2048 x 1152 */
@media (min-width: 2048px) { 


  
}

/* 2304-1440 */
@media (min-width: 2304px) { 
    nav {
        .nav-logo {
            width: 160px;
        }
    
        .nav-links {
            gap: 48px;
            
            a {
                font-size: 25px;
            }
        }

        .nav-btns { 
            gap: 38px;
        }
    }


    .default-btn { 
        font-size: 22px;
        width: 210px;
    }
   
}

/* 2470 - 1328 */
@media (min-width: 2470px) {
 
 
}

/*2560-1440*/
@media (min-width: 2560px) {
    nav {
        .nav-logo {
            width: 180px;
        }
    
        .nav-links {
            gap: 52px;
            
            a {
                font-size: 28px;
            }
        }

        .nav-btns { 
            gap: 40px;
        }
    }
 
    .default-btn { 
        font-size: 24px;
        width: 250px;
    } 
}

/* 2880-1670 */
@media(min-width: 2880px) { 
}

/* 3000-1870 */
@media(min-width: 3000px) {
    nav {
        .nav-logo {
            width: 200px;
        }
    
        .nav-links {
            gap: 55px;

            a {
                font-size: 30px;
            }
        }

        .nav-btns { 
            gap: 45px;
        }
    }
 
    .default-btn { 
        font-size: 26px;
        width: 300px;
    }
}

/*3200-1800*/
@media(min-width: 3200px) {
    
}

/*3360-1890 1695*/
@media(min-width:3360px) { 
 
}
 
@media(max-width: 1800px){
  
}

/* macbook pro 16 2021 */
/*1728x1085*/
@media(max-width: 1728px) {
  
}

/*1680-1080*/
@media(max-width: 1680px) {

}

/*1640-1080*/
@media(max-width: 1640px) {
 
}

/*my big monitor 1600 - 757 */
@media (max-width: 1600px) {    

}

/*my small monitor 1536-864*/
@media(max-width:1536px) {
    nav {
        .nav-logo { 
            width: 100px;  
        } 

        .nav-links a{ 
            font-size: 16px;
        }
    }
 
    .default-btn { 
        padding: 10px 0;
        font-size: 16px; 
    }
}


/* 1440-990 */
@media(max-width:1440px) {
    nav {
        .nav-links { 
            gap: 38px;
        }

        .nav-btns { 
            gap: 25px;
        }   
    }
}

/*1366-768*/
@media (max-width:1366px) {

}

/* 1280-800 */
@media (max-width:1280px) { 
    nav {
        width: 90%;
    } 
}

@media (max-width:1200px) { 
    nav {
        .nav-logo {
            width: 90px;
        }

        .nav-links {
            gap: 35px;

            a{
                font-size: 14px;
            }
        }
    }
 
    .default-btn { 
        width: 160px; 
        font-size: 14px;
    } 
}

/*1134x712*/
@media(max-width:1134px) {
    
}

/*1114x705*/
@media(max-width:1114px) {
 
}

/*1024-768*/
@media (max-width:1024px) {
      
}

/* ipad pro 2/3 */
/* 981x1024 */
@media (max-width:981px) {
    nav {
        width: 95%;
    }

}

/* 962x601 */
@media(max-width: 962px) {
    nav {
        .nav-links {
            gap: 25px;
        }

        .nav-btns {
            gap: 20px;
        }
    }

}

/* 900x1600 */
@media(max-width: 900px) {
    nav {
        .nav-links {
            gap: 20px;
        }

        .nav-btns {
            gap: 16px;
        }
    }
}

/* 884 x 1104 */
@media(max-width: 884px) {

}

/*834-1112*/
@media(max-width: 834px) {
    nav .nav-links {
        gap: 14px;
    } 
}

/* 820x1080 */
@media(max-width: 820px) {}

/* 800x1280 */
@media(max-width: 800px) {
   
}

/*778-304*/
@media(max-width: 778px) {}

/* 768x1024 */
@media(max-width: 768px) { 
    .login-menu-link-wrapper a{
        border: 1px solid #FF3A67;
        border-radius: 20px;
        padding: 4px 15px;
        color: #FF3A67;
    } 
}

/*712-1138*/
@media(max-width:712px) { 
}

/* 694-768 */
@media(max-width:694px) {
 
}

/* 678-1024 */
@media(max-width:678px) {
 
}

/* 600x962 */
@media(max-width:600px) { 
    .default-btn{
        width: 176px;
    } 
} 

/* 577-951 */
@media(max-width:577px) {}

/* 540-960 */
@media(max-width:540px) {
 
}

/*480-800*/
@media (max-width:480px) { 
    nav {
        width: 95%;
    } 
}

/*438-1024*/
@media(max-width:438px) { 
}

/* ip14 pro max */
/* 430x932 */
@media(max-width:430px){
 
}

/* ip13 pro max */
/* 428-926 */
@media (max-width:428px){
   
}

/*414-736 617   */
@media (max-width:414px) {
 
}

/*390 x 844*/
@media(max-width:393px) {
 
}

/*384-640*/
@media(max-width:384px) {
}

/*375*/
@media(max-width:375px) { 
 
}

/*360x640*/
@media(max-width:360px) {
   
}

/*320x568*/
@media(max-width:320px) {
 
}
</style>
